import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { action, observable } from 'mobx-angular';
import { lastValueFrom } from 'rxjs';

import { RecourseBookingDto } from '../../api/tur-rc/models';
import { RecourseBookingService } from '../../api/tur-rc/services';
import { RecourseBookingModel } from '../../content/recourse-booking/model/recourse-booking-model';
import { BookingStateEnum } from '../../shared/enums/booking-state-enum';
import { NotificationServiceWrapper } from '../notification-service-wrapper/notification-service-wrapper';

import { BookingService } from './booking.service';

@Injectable({
  providedIn: 'root',
})
export class RecourseBookingStore {
  private readonly deprecatedBookingService = inject(BookingService);
  private readonly bookingService = inject(RecourseBookingService);
  private readonly translateService = inject(TranslateService);
  private readonly notificationServiceWrapper = inject(NotificationServiceWrapper);

  @observable
  public recourseBookingModels?: RecourseBookingDto[];

  @observable
  public bookingTypes: any[] = [];

  @observable
  public currencyKeys: string[] = [];

  @observable
  public selectedRecourseBookingId: number;

  @observable
  public recourseId: string;

  @observable
  public recourseCampaignExId: string;

  @observable
  public selectedRecourseBooking: RecourseBookingModel;

  @observable
  public recourseBookingPendingApprovals: RecourseBookingModel[];

  @observable
  public newCorrectionBookingData: RecourseBookingModel;

  @action
  public async getRecourseBookings(): Promise<RecourseBookingDto[]> {
    // TODO: why do we convert observables to promises here? change this (somewhen)
    this.recourseBookingModels = await lastValueFrom(this.bookingService.getAllRecourseBookings());
    return this.recourseBookingModels;
  }

  @action
  public setSelectedRecourseBookingId(selectedRecourseBookingId: number): void {
    this.selectedRecourseBookingId = selectedRecourseBookingId;
  }

  @action
  public setSelectedRecourseBooking(selectedRecourseBooking: RecourseBookingModel): void {
    this.selectedRecourseBooking = selectedRecourseBooking;
  }

  @action
  public updateSelectedRecourseBookingState(bookingState: BookingStateEnum): void {
    this.selectedRecourseBooking.bookingStateId = bookingState;
  }

  @action
  public setBookingTypes(bts: string[]): void {
    this.bookingTypes = bts;
  }

  @action
  public setCurrencyKeys(cks: string[]): void {
    this.currencyKeys = cks;
  }

  @action
  public setRecourseId(recourseId: string): void {
    this.recourseId = recourseId;
  }

  @action
  public setRecourseCampaignExId(recourseCampaignExId: string): void {
    this.recourseCampaignExId = recourseCampaignExId;
  }

  @action
  public setNewCorrectionBookingData(newCorrectionBookingData: RecourseBookingModel): void {
    this.newCorrectionBookingData = newCorrectionBookingData;
  }

  @action
  public async getRecourseBookingDetails(bookingId: number, isEditMode?: boolean): Promise<boolean> {
    try {
      this.setSelectedRecourseBooking(
        await lastValueFrom(this.deprecatedBookingService.getRecourseBookingDetails(bookingId, isEditMode)),
      );
      this.setSelectedRecourseBookingId(bookingId);
      return true;
    } catch {
      this.notificationServiceWrapper.addErrorNotification(
        this.translateService.instant('NOTIFICATION_UNEXPECTED_ERROR_HEADER'),
        this.translateService.instant('NOTIFICATION_UNEXPECTED_ERROR_MESSAGE'),
      );
      return false;
    }
  }
}
